import { motion } from "framer-motion";

export default function NextSection() {
  return (
    <section className="w-full bg-gray-50 py-12 flex justify-center">
      <motion.div
        className="max-w-2xl text-center px-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
          Join thousands of innovators today
        </h2>
        <p className="mt-4 text-gray-600">
          Take the first step toward building your startup success story.
          Download our app and connect with the resources you need.
        </p>

        <motion.button
          className="mt-6 px-6 py-3 text-white rounded shadow-md"
          style={{ backgroundColor: "#0C4A99" }}
          whileHover={{
            scale: 1.05,
            backgroundColor: "#042C6B",
            transition: { duration: 0.6, ease: "easeOut" },
          }}
          whileTap={{
            scale: 0.97,
            transition: { duration: 0.3, ease: "easeInOut" },
          }}
        >
          Get it now in Play Store
        </motion.button>
      </motion.div>
    </section>
  );
}
